import React from 'react'
import { Translate } from 'react-localize-redux'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import {
  Paper,
  Tabs,
  Tab,
  Toolbar,
  Typography,
  Box,
  Grid,
} from '@material-ui/core'
import useTeamFeature from 'hooks/useTeamFeature'
import { FavoritesLoader } from 'loaders'
import TeaserChip from 'components/Teaser/TeaserChip'
import {
  ArticlesCarousel,
  DrillsCarousel,
  TrainingPackagesCarousel,
  VideosCarousel,
  SequencesCarousel,
} from './components'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const MuiBox = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(Box)
const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    minHeight: 50,
    borderBottom: '1px solid #e8e8e8',
  },
  title: {
    flex: '1 1 100%',
  },
}))

const FavoritesContainer = () => {
  const classes = useToolbarStyles()

  const { enabled: hasVideoSectionEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.video_manager_enabled
  )
  const { enabled: hasSequencesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.sequences_enabled
  )
  const { enabled: hasKnowledgeEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.knowledge_enabled
  )
  const { enabled: hasActivitiesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.activities_enabled
  )
  const { enabled: hasTrainingPackagesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.training_packages_enabled
  )

  const [value, setValue] = React.useState(0)
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <>
      <Toolbar className={classes.root}>
        <Typography variant="h4" component="h4">
          <Translate id="navbar.favorites" />
        </Typography>
      </Toolbar>
      <Paper className={classes.paper}>
        <Toolbar className={classes.root}>
          <Tabs
            value={value}
            className={classes.title}
            onChange={handleChange}
            variant="scrollable"
            indicatorColor="primary"
            scrollButtons="auto"
          >
            <Tab
              label={
                <Grid alignItems="center" container justifyContent="center">
                  <Translate id="home.articles" />
                  {!hasKnowledgeEnabled && <TeaserChip />}
                </Grid>
              }
            />
            <Tab
              label={
                <Grid alignItems="center" container justifyContent="center">
                  <Translate id="home.drills" />
                  {!hasActivitiesEnabled && <TeaserChip />}
                </Grid>
              }
            />
            <Tab
              label={
                <Grid alignItems="center" container justifyContent="center">
                  <Translate id="navbar.training_packages" />
                  {!hasTrainingPackagesEnabled && <TeaserChip />}
                </Grid>
              }
            />
            <Tab
              label={
                <Grid alignItems="center" container justifyContent="center">
                  <Translate id="videos.videos" />
                  {!hasVideoSectionEnabled && <TeaserChip />}
                </Grid>
              }
            />
            <Tab
              label={
                <Grid alignItems="center" container justifyContent="center">
                  <Translate id="videos.sequences" />
                  {!hasSequencesEnabled && <TeaserChip />}
                </Grid>
              }
            />
          </Tabs>
        </Toolbar>
        <MuiBox>
          {value === 0 && <ArticlesCarousel changeTab={setValue} />}
          {value === 1 && <DrillsCarousel changeTab={setValue} />}
          {value === 2 && <TrainingPackagesCarousel changeTab={setValue} />}
          {value === 3 && (
            <FavoritesLoader entity="videos" alwaysRenderChildren>
              <VideosCarousel changeTab={setValue} />
            </FavoritesLoader>
          )}
          {value === 4 && (
            <FavoritesLoader entity="sequences" alwaysRenderChildren>
              <SequencesCarousel changeTab={setValue} />
            </FavoritesLoader>
          )}
        </MuiBox>
      </Paper>
    </>
  )
}

export default FavoritesContainer
